// @flow
import mediatorChannels from "@tvg/mediator";
import { get } from "lodash";
import pushToDataLayer from "../gtmUtils";

type HeaderGTMTypeEvents = "HEADER_GO_BACK";

type backGTMButton = {
  type: HeaderGTMTypeEvents,
  payload?: {
    gaEventLabel?: string,
    module?: string,
    microApp?: string,
    destinationUrl?: string
  }
};

export default () => {
  mediatorChannels.base.subscribe("HEADER_LOGIN_WALL", () => {
    pushToDataLayer({
      event: "Site click",
      gaEventCategory: "Site Click",
      gaEventAction: "Open",
      gaEventLabel: undefined,
      module: "header",
      microApp: "non-Microapp"
    });
  });
};
